/*
  Main 관리 (2018/06/01 정재윤)
    - App Ready 상태 확인
    - Vue 인스턴스 생성
    - App.vue 로딩
*/

import '~core'
import Router from '~fdp/core/router/router.js'
import rootRoutes from '@/config/router/rootRoutes'

import './init'

import VueGtm from 'vue-gtm'

/* common module import */
import WepUtilsPlugin from '@/plugins/_common/WepUtils'
import WepResourcePlugin from '@/plugins/_common/WepResource'
import WepPopup from '@/plugins/_common/WepPopup'
import WepVeeValidate from '@/plugins/_common/WepVeeValidate'
import VueLoadScript from '@/plugins/_common/VueLoadScript'
import WepPostMessage from '@/plugins/_common/WepPostMessage'
import VueSwiper from '@/plugins/_common/VueSwiper'
import WepBeforeRouteCheck from '@/plugins/_common/WepBeforeRouteCheck'
import CommonMixin from '@/mixin/method/CommonMethodMixin' // 공통 메서드 사용
import WepHtmlToString from '@/plugins/_common/WepHtmlToString' // 공통 메서드 사용
import VueSlimScroll from 'vue-slimscroll'
import 'fullpage.js/vendors/scrolloverflow' // Optional. When using scrollOverflow:true
import VueFullPage from 'vue-fullpage.js'

// Google Analytics
import VueGtag from 'vue-gtag'
import { isEmpty } from 'lodash'

// Import stylesheet
import '@/assets/css/font.css'
import '@/assets/css/reset.css'

import Vue from 'vue'
import App from './App/App'

Vue.config.productionTip = false

// Vue 인스턴스 생성
const locale = localStorage.getItem('language') || window.vue.config.app.defaultLocale

// load http module

Vue.use(WepResourcePlugin)
Vue.mixin(CommonMixin)

window.vue.setLocaleResource(locale)
  .then(() => {
    // success
  }).catch((error) => {
    // fail
    console.error(error)
    window.vue.setLocale(locale)
  }).finally(() => {
    createVue()
  })

const createVue = async () => {
  // let httpObj = window.vue.getInstance('http')
  await rootRoutes.generateRouter(Router)

  // document.getElementById('app').classList.remove('lds-roller')

  /* common module install */
  /* common module install */
  Vue.use(WepUtilsPlugin)
  Vue.use(WepPopup)
  Vue.use(WepVeeValidate)
  Vue.use(VueLoadScript)
  Vue.use(WepPostMessage)
  Vue.use(VueSwiper)
  Vue.use(VueSlimScroll)
  Vue.use(WepHtmlToString)
  Vue.use(VueFullPage)
  let isPhone = Vue.utils.userAgent.isPhone()
  let isTablet = Vue.utils.userAgent.isTablet()
  let isDesktop = Vue.utils.userAgent.isDesktop()
  let isApp = Vue.utils.userAgent.isApp()

  var routerObj = window.vue.getInstance('router')

  console.log('router ', routerObj)
  console.log('userAgent', 'isPhone: ', isPhone ? 'O' : 'X', 'isTablet:', isTablet ? 'O' : 'X', 'isDesktop', isDesktop ? 'O' : 'X', 'isApp', isApp ? 'O' : 'X')

  Vue.use(WepBeforeRouteCheck)

  // Google Analytics Code Get
  let wepSets = JSON.parse(localStorage.getItem('mmp-app-mmpAuth-wepSets')).wepSets // Session Data Get
  let gaCd = wepSets.gaCd // GA Code Get

  // GA Code
  if (!isEmpty(gaCd)) {
    Vue.use(VueGtag, {
      config: { id: gaCd } // Test용 'G-7Y67N9978V'
    }, routerObj)
  }
  let gtmCd = wepSets.gtmCd // GA Code Get

  if (!isEmpty(gtmCd)) {
    Vue.use(VueGtm, {
      id: gtmCd,
      vueRouter: routerObj,
      loadScript: true,
      debug: true,
      enable: true
    })
  }
  if (window.vue.getInstance('vue') === undefined) {
    const vueInstance = new Vue({
      el: '#app',
      components: { App },
      i18n: window.vue.getI18n(),
      router: routerObj,
      render: function (createElement) {
        return createElement(App)
      }
    })
    window.vue.setInstance('vue', vueInstance)
  }
}



// WEBPACK FOOTER //
// ./src/main.js